import store from '@/store/index'

export const isManagerGuard = (redirectPath) => (to, from, next) => {
  if (!store.getters['auth/isManager']) {
    store.commit('notify/set', {message: '許可されていないアクションです'})
    next(redirectPath)
    return
  }
  next()
}

// profileの各edit画面は本人のみアクセスできるようにする
export const profileEditGuard = (to, from, next) => {
  if (to.params.id === store.state.auth.user.id) {
    next()
    return
  }
  store.commit('notify/set', {message: '許可されていないアクションです'})
  next(`/members/${to.params.id}`)
}

export const availablePathNamesForParentMember = ['events', 'settings', 'members', 'goalList', 'mandalaEvaluation']
